export const ELEMENT_TYPES = {
  CheckoutModal: 'CheckoutModal',
  CheckoutInline: 'CheckoutInline',
} as const

export type ElementType = (typeof ELEMENT_TYPES)[keyof typeof ELEMENT_TYPES]

export const CHECKOUT_MESSAGES = {
  LOADED: 'checkout:loaded',
  ERROR: 'checkout:error',
  BACK: 'checkout:back',
  CLOSE: 'checkout:close-checkout',
  PAYMENT_SUCCESS: 'checkout:payment-success',
  PAYMENT_PROCESSING: 'checkout:payment-processing',
  PAYMENT_ERROR: 'checkout:payment-error',
} as const

export type CheckoutMessageType = (typeof CHECKOUT_MESSAGES)[keyof typeof CHECKOUT_MESSAGES]

export const ELEMENT_STATUSES = {
  IDLE: 'idle',
  READY: 'ready',
  DESTROYED: 'destroyed',
} as const

export type BillingElementsStatus = (typeof ELEMENT_STATUSES)[keyof typeof ELEMENT_STATUSES]

export type CheckoutRoute = 'assinar' | 'cobranca' | 'atualizar'

export type CheckoutMessagePayload = Record<string, unknown>

interface BillingElementsBaseOptions {
  onLoaded?: (data?: CheckoutMessagePayload) => void
  onError?: (data?: CheckoutMessagePayload) => void
  onBack?: () => void
  onClose?: () => void
  onPaymentSuccess?: (data?: CheckoutMessagePayload) => void
  onPaymentProcessing?: (data?: CheckoutMessagePayload) => void
  onPaymentError?: (data?: CheckoutMessagePayload) => void
}

interface BillingElementsRouteOptions {
  route: CheckoutRoute
  checkoutData: Record<string, string>
  queryParams?: Record<string, string>
  _src?: never
}

interface BillingElementsSrcOptions {
  _src: string
  checkoutData?: Record<string, string>
  route?: never
  queryParams?: never
}

export type BillingElementsOptions = BillingElementsBaseOptions &
  (BillingElementsRouteOptions | BillingElementsSrcOptions)
